<ng-template #inputErrorGeneral let-error>
  <ng-container *ngIf="showErrors && error !== null">
    <mat-error>
      {{ error }}
    </mat-error>
  </ng-container>
</ng-template>

<div class="episode-time-content container">
  <div class="row">
    <div class="col-lg-6">
      <!-- <div class="row">
        <div 
          class="col-lg-12"
          data-testid="epg-episode-start-date-column"
          (click)="episodeStartDatePicker.open()"
        >
          <mat-form-field appearance="fill">
            <mat-label>Start date</mat-label>
            <input
              #startDateInputElement
              matInput
              data-testid="epg-episode-start-date-input"
              [matDatetimepicker]="episodeStartDatePicker"
              [matDatepickerFilter]="startDateMaterialDatePickerFilter"
              [value]="viewData.start.date"
              (dateInput)="onChangeStartDate($event)"
            />           
            <mat-datetimepicker-toggle
              data-testid="epg-episode-start-date-datepicker-toggle"
              class="clear-suffix"
              [for]="episodeStartDatePicker"
              matSuffix
            >
            </mat-datetimepicker-toggle>
            <mat-datetimepicker
              #episodeStartDatePicker
              type="datetime"
              [openOnFocus]="true"
              [timeInterval]="5"
            >
            </mat-datetimepicker>              
          </mat-form-field>
          <ng-container
            [ngTemplateOutletContext]="{ $implicit: errors.start.date }"
            [ngTemplateOutlet]="inputErrorGeneral"
          ></ng-container>
        </div>
      </div> -->
      <div class="row">
        <div class="col-lg-4">
          <mat-form-field appearance="fill">
            <mat-label>Duration</mat-label>
            <input
              #durationInput
              data-testid="epg-episode-duration-input"
              matInput
              [matTooltip]="
                viewData.schedule.type === EpisodeScheduleType.Indefinite
                  ? 'This option is not available for indefinite episodes'
                  : ''
              "
              [disabled]="
                viewData.schedule.type === EpisodeScheduleType.Indefinite
              "
              [value]="viewData.duration"
              (input)="onChangeDuration(durationInput)"
              placeholder="Duration in minutes"
              type="text"
            />
            <div matSuffix class="clear-suffix">Mins</div>
          </mat-form-field>
          <ng-container
            [ngTemplateOutletContext]="{ $implicit: errors.duration }"
            [ngTemplateOutlet]="inputErrorGeneral"
          ></ng-container>
        </div>
        <!--<div class="col-lg-8">
          <mat-form-field appearance="fill">
            <mat-label>Time Zone</mat-label>
            <mat-icon matSuffix>expand_more</mat-icon>
            <mat-select
              [disabled]="true"
              #repeatsSelectInput
              matTooltip="Option not available"
              [disabled]="true"
              placeholder="Time Zone"
              data-testid="epg-episode-time-zone-select"
              [value]="true"
            >
              <mat-option [disabled]="true" [value]="true">
                EST
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>-->
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="episode-time-date-label">
            <div class="episode-time-date-label-start">
              <mat-icon class="episode-time-date-label-start-icon material-symbols-outlined">schedule</mat-icon>
            </div>
            <div class="episode-time-date-label-mid">
              <span class="episode-time-date-label-mid-label">End Time</span>
              <span class="episode-time-date-label-mid-value">
                {{getMommentFormatDate(viewData.schedule.end.date)}}
              </span>
            </div>
            <div class="episode-time-date-label-end">
              <mat-icon class="episode-time-date-label-end-icon material-symbols-outlined">calendar_clock</mat-icon>
              <span class="episode-time-date-label-end-label">{{getDatesDiference()}}</span>
            </div>
          </div>
        </div>
        <!--<div 
          class="col-lg-12"
          data-testid="epg-episode-end-date-column"
          (click)="episodeEndDatePicker.open()"
        >
          <mat-form-field appearance="fill">
            <mat-label>End date</mat-label>
            <input
              matInput
              [readonly]="true"
              data-testid="epg-episode-end-date-input"
              [matDatepicker]="episodeEndDatePicker"
              [matDatepickerFilter]="endDateMaterialDatePickerFilter"
              (dateInput)="onChangeEndDate($event)"
              [value]="viewData.schedule.end.date"
            />
            <mat-datepicker-toggle
              matSuffix
              data-testid="epg-episode-end-date-datepicker-toggle"
              [for]="episodeEndDatePicker"
            >
            </mat-datepicker-toggle>
            <mat-datepicker #episodeEndDatePicker></mat-datepicker>
          </mat-form-field>
          <ng-container
            [ngTemplateOutletContext]="{ $implicit: errors.end.date }"
            [ngTemplateOutlet]="inputErrorGeneral"
          ></ng-container>
        </div>-->
      </div>
    </div>
   <!--<div class="col-lg-6 episode-time-extra-details-wrapper">
      <div class="row episode-time-extra-details-wrapper">
        <div class="episode-time-extra-details-container">
          <div class="episode-time-extra-details-title">
           <mat-icon matSuffix>event_repeat</mat-icon>
           <span>Recurrence</span> 
          </div>
          <div class="container episode-time-extra-details-content">
            <div class="row">
              <div class="col-lg-6">
                <mat-form-field appearance="fill">
                  <mat-label>Repeats</mat-label>
                  <mat-icon matSuffix>expand_more</mat-icon>
                  <mat-select
                    #repeatsSelectInput
                    [matTooltip]="'This option is not available'"
                    [disabled]="true"
                    placeholder="Repeats"
                    data-testid="epg-episode-repeats-select"
                    [value]="viewData.schedule.type"
                    (selectionChange)="onEpisodeScheduleTypeSelectionChange($event, repeatsSelectInput)"
                  >
                    <mat-option [disabled]="true" [value]="EpisodeScheduleType.Definite">
                      Don't Repeat
                    </mat-option>
                    <mat-option
                      [disabled]="true"
                      [value]="EpisodeScheduleType.Indefinite"
                      [ngClass]="{
                        'd-none':
                          viewData.schedule.type !== EpisodeScheduleType.Indefinite
                      }"
                    >
                      Runs indefinitely
                    </mat-option>
                    <mat-option
                      [disabled]="true"
                      [value]="EpisodeScheduleType.Recurring"
                      (click)="onRecurringOptionClick()"
                    >
                      {{
                        viewData.schedule.type === EpisodeScheduleType.Recurring
                          ? viewData.formattedRecurrence
                          : "Set..."
                      }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>          
        </div>
      </div>    
    </div>-->
  </div>

  <!-- DELETE Start time and runs indefinitely 
  <div class="row">
    <div class="col-lg-6">
      <mat-form-field appearance="fill">
        <mat-label>Start time</mat-label>
        <input
          #episodeStartTimeEl
          matInput
          data-testid="epg-episode-start-time-input"
          placeholder="i.e. 01:30 AM"
          (input)="onChangeStartTime(episodeStartTimeEl, $event)"
          [value]="viewData.start.time"
          type="text"
        />
      </mat-form-field>
      <ng-container
        [ngTemplateOutletContext]="{ $implicit: errors.start.time }"
        [ngTemplateOutlet]="inputErrorGeneral"
      ></ng-container>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-6">
      <mat-checkbox
        [disabled]="
          viewData.schedule.type === EpisodeScheduleType.Recurring
        "
        [checked]="
          viewData.schedule.type === EpisodeScheduleType.Indefinite
        "
        [matTooltip]="
          viewData.schedule.type === EpisodeScheduleType.Recurring
            ? 'This option is not available when the episode is set to repeat'
            : ''
        "
        [ngClass]="{
          'mb-3': errors.runsIndefinitely !== null
        }"
        (change)="onChangeRunsIndefinitely($event)"
      >
        Runs indefinitely
      </mat-checkbox>
      <ng-container
        [ngTemplateOutletContext]="{ $implicit: errors.runsIndefinitely }"
        [ngTemplateOutlet]="inputErrorGeneral"
      ></ng-container>
    </div>
  </div>
  <div
    class="row"
    *ngIf="viewData.schedule.type === EpisodeScheduleType.Definite"
  >
    <div class="col-lg-6">
      <mat-form-field appearance="fill">
        <mat-label>End time</mat-label>
        <input
          #episodeEndTimeEl
          matInput
          placeholder="End time"
          data-testid="epg-episode-end-time-input"
          [value]="viewData.schedule.end.time"
          (input)="onChangeEndTime(episodeEndTimeEl)"
          type="text"
        />
      </mat-form-field>
      <ng-container
        [ngTemplateOutletContext]="{ $implicit: errors.end.time }"
        [ngTemplateOutlet]="inputErrorGeneral"
      ></ng-container>
    </div>
  </div>-->

</div>     